import React from "react";

interface InfoProps {
    className?: string;
}

const Info: React.FC<InfoProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="17px"
      height="17px"
      viewBox="0 0 17 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: -3, cursor: "pointer" }}
    >
      <title>Info</title>
      <g
        id="Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="PWA-Desktop-Page6----Result---Other-Application"
          transform="translate(-399.000000, -695.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Group-12" transform="translate(159.000000, 449.000000)">
            <g id="Group-17">
              <g id="Group-11">
                <g
                  id="Group-6-Copy"
                  transform="translate(30.000000, 151.000000)"
                >
                  <g id="Group-3-Copy-2">
                    <g id="Group-2" transform="translate(210.000000, 5.000000)">
                      <g id="np_info_2606847_000000">
                        <path
                          d="M9.71428571,96.0714286 L7.28571429,96.0714286 L7.28571429,93.6428571 L9.71428571,93.6428571 L9.71428571,96.0714286 Z M9.71428571,103.357143 L7.28571429,103.357143 L7.28571429,97.2857143 L9.71428571,97.2857143 L9.71428571,103.357143 Z M8.5,90 C6.24589714,90 4.08388571,90.8955406 2.48918857,92.4891886 C0.895443429,94.0836914 0,96.2458971 0,98.5 C0,100.754103 0.895540571,102.916114 2.48918857,104.510811 C4.08369143,106.104557 6.24589714,107 8.5,107 C10.7541029,107 12.9161143,106.104459 14.5108114,104.510811 C16.1045566,102.916309 17,100.754103 17,98.5 C17,96.2458971 16.1044594,94.0838857 14.5108114,92.4891886 C12.9163086,90.8954434 10.7541029,90 8.5,90 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Info;
